let baseURL: any

export type ConfigProps = {
    Sidebar_drawer: any
    Customizer_drawer: boolean
    mini_sidebar: boolean
    setHorizontalLayout: boolean
    setRTLLayout: boolean
    actTheme: string
    boxed: boolean
    setBorderCard: boolean
    sidebarWidth: 'compact' | 'default' | 'wide'
    fontSize: 'small' | 'medium' | 'large'
    compactMode: boolean
    animations: boolean
    googleMapApiKey: string
    baseURL: string
    geoapifyKey: string
}

const config: ConfigProps = {
    Sidebar_drawer: true,
    Customizer_drawer: false,
    mini_sidebar: false,
    setHorizontalLayout: false,
    setRTLLayout: false,
    actTheme: 'ORANGE_THEME',
    boxed: false,
    setBorderCard: false,
    sidebarWidth: 'default',
    fontSize: 'medium',
    compactMode: false,
    animations: true,
    googleMapApiKey: 'AIzaSyDVTZPM4E8lXdyuesfnlioaBkyjNfWHZGg',
    baseURL: import.meta.env.VITE_BASE_URL,
    geoapifyKey: '8c73f5317dfd468e940ad346a0de7084',
}

export default config
